import { render, staticRenderFns } from "./WorkflowTable.vue?vue&type=template&id=3b1c4428&lang=html"
import script from "./WorkflowTable.vue?vue&type=script&lang=js"
export * from "./WorkflowTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports